(function() {
'use strict';

/* ── Helpers ─────────────────────────────────────────── */
function $(id) { return document.getElementById(id); }
var state = { family:null, spec:null, feature:null, screen:null };
var activeColour = {};

/* ══════════════════════════════════════════════════════
   PRODUCT DATA — all VIDs from Matrixify export
   ══════════════════════════════════════════════════════ */

/*
  Product map key: family + '-' + spec + '-' + feature
  feature values: x | max-trans | max-dbw | max-trans-dbw | max-only
  screen: with/without (T suffix)
*/

var PRODUCTS = {

  /* ── GM LS Gen III 24x ──────────────────────────────── */
  /* Terminator X standard */
  'ls_gen3-ls1_ev1-x': {
    name: 'Terminator X - LS1/LS6 24x EV1',
    desc: 'Plug-and-play for LS1 and LS6 engines with 24x crank reluctor and EV1 injector connectors. Includes 3.5" touchscreen handheld.',
    specs: { engine:'LS1/LS6 24x', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-903', vid:51418558660902, price:1214.06, handle:'550-903' },
    noscreen: { sku:'550-903T', vid:52171046289702, price:1133.06, handle:'550-903' }
  },
  'ls_gen3-truck_ev1-x': {
    name: 'Terminator X - Gen III Truck 24x EV1',
    desc: '4.8/5.3/6.0 truck engines with 24x crank and EV1 (Multec 2) injector connectors.',
    specs: { engine:'Gen III Truck 24x', injectors:'Multec 2 / EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-904', vid:51418558497062, price:1303.95, handle:'550-904' },
    noscreen: { sku:'550-904T', vid:52171046322470, price:1133.06, handle:'550-904' }
  },
  'ls_gen3-ls1_ev6-x': {
    name: 'Terminator X - LS1/LS6 24x EV6',
    desc: 'LS1/LS6 with 24x crank and EV6 (USCAR) injector connectors. Common in swap builds using later injectors.',
    specs: { engine:'LS1/LS6 24x', injectors:'EV6', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-909', vid:51418558726438, price:1214.06, handle:'550-909' },
    noscreen: { sku:'550-909T', vid:52171049566502, price:1133.06, handle:'550-909' }
  },
  /* Terminator X Max — trans only */
  'ls_gen3-ls1_ev1-max-trans': {
    name: 'Terminator X Max - LS1/LS6 24x EV1 + Trans',
    desc: 'LS1/LS6 with EV1 injectors and 4L60E/4L80E transmission control.',
    specs: { engine:'LS1/LS6 24x', injectors:'EV1', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-916', vid:51418557776166, price:1663.95, handle:'550-916' },
    noscreen: { sku:'550-916T', vid:52171052843302, price:1497.56, handle:'550-916' }
  },
  'ls_gen3-truck_ev1-max-trans': {
    name: 'Terminator X Max - Gen III Truck 24x + Trans',
    desc: 'Gen III truck with EV1 injectors and 4L60E/4L80E trans control.',
    specs: { engine:'Gen III Truck 24x', injectors:'Multec 2 / EV1', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-917', vid:51418557579558, price:1663.95, handle:'550-917' },
    noscreen: { sku:'550-917T', vid:52171052876070, price:1497.56, handle:'550-917' }
  },
  'ls_gen3-ls1_ev6-max-trans': {
    name: 'Terminator X Max - LS1/LS6 24x EV6 + Trans',
    desc: 'LS1/LS6 with EV6 injectors and 4L60E/4L80E trans control.',
    specs: { engine:'LS1/LS6 24x', injectors:'EV6', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-919', vid:51418557874470, price:1538.06, handle:'550-919' },
    noscreen: { sku:'550-919T', vid:52171056152870, price:1497.56, handle:'550-919' }
  },
  /* Terminator X Max — trans + DBW */
  'ls_gen3-ls1_ev1-max-trans-dbw': {
    name: 'Terminator X Max - LS1/LS6 24x EV1 + Trans + DBW',
    desc: 'LS1/LS6 with EV1 injectors, 4L60E/4L80E trans control and drive-by-wire throttle body.',
    specs: { engine:'LS1/LS6 24x', injectors:'EV1', trans:'4L60E/4L80E + DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-926', vid:51418557448486, price:1843.95, handle:'550-926' },
    noscreen: { sku:'550-926T', vid:52171056218406, price:1659.56, handle:'550-926' }
  },
  'ls_gen3-truck_ev1-max-trans-dbw': {
    name: 'Terminator X Max - Gen III Truck 24x + Trans + DBW',
    desc: 'Gen III truck with EV1 injectors, trans control and DBW.',
    specs: { engine:'Gen III Truck 24x', injectors:'Multec 2 / EV1', trans:'4L60E/4L80E + DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-927', vid:51418557251878, price:1843.95, handle:'550-927' },
    noscreen: { sku:'550-927T', vid:52171059462438, price:1659.56, handle:'550-927' }
  },
  /* Terminator X Max — DBW only */
  'ls_gen3-ls1_ev1-max-dbw': {
    name: 'Terminator X Max - LS1/LS6 24x EV1 + DBW',
    desc: 'LS1/LS6 with EV1 injectors and drive-by-wire control. No trans control.',
    specs: { engine:'LS1/LS6 24x', injectors:'EV1', trans:'DBW only', screen:'3.5" Handheld' },
    screen: { sku:'550-929', vid:51418557088038, price:1663.95, handle:'550-929' },
    noscreen: { sku:'550-929T', vid:52171062772006, price:1497.56, handle:'550-929' }
  },
  'ls_gen3-truck_ev1-max-dbw': {
    name: 'Terminator X Max - Gen III Truck 24x + DBW',
    desc: 'Gen III truck with EV1 injectors and DBW control.',
    specs: { engine:'Gen III Truck 24x', injectors:'Multec 2 / EV1', trans:'DBW only', screen:'3.5" Handheld' },
    screen: { sku:'550-930', vid:51418556891430, price:1663.95, handle:'550-930' },
    noscreen: { sku:'550-930T', vid:52171062804774, price:1497.56, handle:'550-930' }
  },
  'ls_gen3-ls1_ev6-max-dbw': {
    name: 'Terminator X Max - LS1/LS6 24x EV6 + DBW',
    desc: 'LS1/LS6 with EV6 injectors and DBW control.',
    specs: { engine:'LS1/LS6 24x', injectors:'EV6', trans:'DBW only', screen:'3.5" Handheld' },
    screen: { sku:'550-932', vid:51418557153574, price:1538.06, handle:'550-932' },
    noscreen: { sku:'550-932T', vid:52171062968614, price:1497.56, handle:'550-932' }
  },
  /* Terminator X Max — Max ECU only (no trans, no DBW) */
  'ls_gen3-ls1_ev1-max-only': {
    name: 'Terminator X Max - LS1/LS6 24x EV1 (Max ECU)',
    desc: 'Max ECU features without trans or DBW. For future-proofing or advanced tuning features.',
    specs: { engine:'LS1/LS6 24x', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-934', vid:51418557514022, price:1700.06, handle:'550-934' },
    noscreen: { sku:'550-934T', vid:52171063066918, price:1659.56, handle:'550-934' }
  },

  /* ── GM LS Gen IV 58x ───────────────────────────────── */
  'ls_gen4-ls2_ev1-x': {
    name: 'Terminator X - LS2/LS3 58x EV1',
    desc: 'LS2, LS3, LS7 and Gen IV truck with 58x crank and EV1 injector connectors.',
    specs: { engine:'LS2/LS3/Gen IV 58x', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-905', vid:51418558791974, price:1214.06, handle:'550-905' },
    noscreen: { sku:'550-905T', vid:52171046355238, price:1133.06, handle:'550-905' }
  },
  'ls_gen4-ls2_ev6-x': {
    name: 'Terminator X - LS2/LS3 58x EV6',
    desc: 'LS2, LS3, LS7 and Gen IV truck with 58x crank and EV6 injector connectors.',
    specs: { engine:'LS2/LS3/Gen IV 58x', injectors:'EV6', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-910', vid:51418558857510, price:1214.06, handle:'550-910' },
    noscreen: { sku:'550-910T', vid:52171052777766, price:1133.06, handle:'550-910' }
  },
  'ls_gen4-ls2_ev6-max-trans': {
    name: 'Terminator X Max - LS2/LS3 58x EV6 + Trans',
    desc: 'LS2/LS3/Gen IV with EV6 injectors and 4L60E/4L80E trans control.',
    specs: { engine:'LS2/LS3/Gen IV 58x', injectors:'EV6', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-918', vid:51418557645094, price:1663.95, handle:'550-918' },
    noscreen: { sku:'550-918T', vid:52171052941606, price:1497.56, handle:'550-918' }
  },
  'ls_gen4-ls2_ev6-max-trans-alt': {
    name: 'Terminator X Max - LS2/LS3 58x EV6 + Trans (Alt)',
    desc: 'Alternative configuration for LS2/LS3 58x with trans control.',
    specs: { engine:'LS2/LS3/Gen IV 58x', injectors:'EV6', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-920', vid:51418557710630, price:1538.06, handle:'550-920' },
    noscreen: { sku:'550-920T', vid:52171056251174, price:1497.56, handle:'550-920' }
  },
  'ls_gen4-ls2_ev6-max-trans-dbw': {
    name: 'Terminator X Max - LS2/LS3 58x EV6 + Trans + DBW',
    desc: 'LS2/LS3 with EV6 injectors, 4L60E/4L80E trans and DBW throttle body.',
    specs: { engine:'LS2/LS3/Gen IV 58x', injectors:'EV6', trans:'4L60E/4L80E + DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-928', vid:51418557317414, price:1843.95, handle:'550-928' },
    noscreen: { sku:'550-928T', vid:52171059560742, price:1659.56, handle:'550-928' }
  },
  'ls_gen4-ls2_ev6-max-dbw': {
    name: 'Terminator X Max - LS2/LS3 58x EV6 + DBW',
    desc: 'LS2/LS3 with EV6 injectors and DBW. No trans control.',
    specs: { engine:'LS2/LS3/Gen IV 58x', injectors:'EV6', trans:'DBW only', screen:'3.5" Handheld' },
    screen: { sku:'550-931', vid:51418556956966, price:1663.95, handle:'550-931' },
    noscreen: { sku:'550-931T', vid:52171062870310, price:1497.56, handle:'550-931' }
  },
  'ls_gen4-ls2_ev6b-max-dbw': {
    name: 'Terminator X Max - LS2/LS3 58x EV6 + DBW (B)',
    desc: 'Alternative LS2/LS3 58x configuration with DBW and EV6.',
    specs: { engine:'LS2/LS3/Gen IV 58x', injectors:'EV6', trans:'DBW only', screen:'3.5" Handheld' },
    screen: { sku:'550-933', vid:51418557022502, price:1538.06, handle:'550-933' },
    noscreen: { sku:'550-933T', vid:52171063034150, price:1497.56, handle:'550-933' }
  },
  'ls_gen4-ls2_ev6-max-only': {
    name: 'Terminator X Max - LS2/LS3 58x EV6 (Max ECU)',
    desc: 'Max ECU for LS2/LS3 58x without trans or DBW.',
    specs: { engine:'LS2/LS3/Gen IV 58x', injectors:'EV6', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-935', vid:51418557382950, price:1700.06, handle:'550-935' },
    noscreen: { sku:'550-935T', vid:52171063132454, price:1659.56, handle:'550-935' }
  },

  /* ── GM Gen V LT ────────────────────────────────────── */
  'lt-early-x': {
    name: 'Terminator X - Gen V LT Early DI',
    desc: 'Gen V LT direct injection - early connector (LT1 2014-2019, L83, L86, L8B). No trans or DBW.',
    specs: { engine:'Gen V LT Early', injectors:'DI', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1600', vid:51418554958118, price:2348.95, handle:'550-1600' },
    noscreen: null
  },
  'lt-late-x': {
    name: 'Terminator X - Gen V LT Late DI',
    desc: 'Gen V LT direct injection - late connector (LT1 2020+, L84, L87). No trans or DBW.',
    specs: { engine:'Gen V LT Late', injectors:'DI', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1601', vid:51418556268838, price:2348.95, handle:'550-1601' },
    noscreen: null
  },
  'lt-early-max-trans': {
    name: 'Terminator X Max - Gen V LT Early + Trans',
    desc: 'Gen V LT early with 4L60E/4L80E transmission control.',
    specs: { engine:'Gen V LT Early', injectors:'DI', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-1610', vid:51418556498214, price:2834.95, handle:'550-1610' },
    noscreen: null
  },
  'lt-late-max-trans': {
    name: 'Terminator X Max - Gen V LT Late + Trans',
    desc: 'Gen V LT late with 4L60E/4L80E transmission control.',
    specs: { engine:'Gen V LT Late', injectors:'DI', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-1611', vid:51418556596518, price:2834.95, handle:'550-1611' },
    noscreen: null
  },
  'lt-early-max-dbw-lt': {
    name: 'Terminator X Max - Gen V LT Early + DBW (LT TB)',
    desc: 'Gen V LT early with LT-style drive-by-wire throttle body. No trans control.',
    specs: { engine:'Gen V LT Early', injectors:'DI', trans:'DBW - LT Throttle Body', screen:'3.5" Handheld' },
    screen: { sku:'550-1620', vid:51418556399910, price:2834.95, handle:'550-1620' },
    noscreen: null
  },
  'lt-early-max-dbw-ls': {
    name: 'Terminator X Max - Gen V LT Early + DBW (LS TB)',
    desc: 'Gen V LT early with LS-style drive-by-wire throttle body. Popular for engine swaps.',
    specs: { engine:'Gen V LT Early', injectors:'DI', trans:'DBW - LS Throttle Body', screen:'3.5" Handheld' },
    screen: { sku:'550-1620LSD', vid:51418556465446, price:2834.95, handle:'550-1620lsd' },
    noscreen: null
  },
  'lt-late-max-dbw-lt': {
    name: 'Terminator X Max - Gen V LT Late + DBW (LT TB)',
    desc: 'Gen V LT late with LT-style DBW throttle body.',
    specs: { engine:'Gen V LT Late', injectors:'DI', trans:'DBW - LT Throttle Body', screen:'3.5" Handheld' },
    screen: { sku:'550-1621', vid:51418556530982, price:3049.95, handle:'550-1621' },
    noscreen: null
  },
  'lt-early-max-trans-dbw-lt': {
    name: 'Terminator X Max - Gen V LT Early + Trans + DBW (LT TB)',
    desc: 'Gen V LT early with 4L60E/4L80E trans and LT-style DBW throttle body.',
    specs: { engine:'Gen V LT Early', injectors:'DI', trans:'4L60E/4L80E + DBW LT', screen:'3.5" Handheld' },
    screen: { sku:'550-1630', vid:51418556432678, price:3299.95, handle:'550-1630' },
    noscreen: null
  },
  'lt-early-max-trans-dbw-ls': {
    name: 'Terminator X Max - Gen V LT Early + Trans + DBW (LS TB)',
    desc: 'Gen V LT early with trans control and LS-style DBW throttle body.',
    specs: { engine:'Gen V LT Early', injectors:'DI', trans:'4L60E/4L80E + DBW LS', screen:'3.5" Handheld' },
    screen: { sku:'550-1630LSD', vid:51418551058726, price:3059.95, handle:'550-1630lsd' },
    noscreen: null
  },
  'lt-late-max-trans-dbw-lt': {
    name: 'Terminator X Max - Gen V LT Late + Trans + DBW (LT TB)',
    desc: 'Gen V LT late with 4L60E/4L80E trans and LT-style DBW throttle body.',
    specs: { engine:'Gen V LT Late', injectors:'DI', trans:'4L60E/4L80E + DBW LT', screen:'3.5" Handheld' },
    screen: { sku:'550-1631', vid:51418556563750, price:3299.95, handle:'550-1631' },
    noscreen: null
  },
  'lt-late-max-trans-dbw-ls': {
    name: 'Terminator X Max - Gen V LT Late + Trans + DBW (LS TB)',
    desc: 'Gen V LT late with trans control and LS-style DBW throttle body.',
    specs: { engine:'Gen V LT Late', injectors:'DI', trans:'4L60E/4L80E + DBW LS', screen:'3.5" Handheld' },
    screen: { sku:'550-1631LSD', vid:51418551091494, price:3059.95, handle:'550-1631lsd' },
    noscreen: null
  },
  'lt-lt4-early-max': {
    name: 'Terminator X Max - Gen V LT4 Early',
    desc: 'Gen V LT4 supercharged engine, early connector.',
    specs: { engine:'Gen V LT4 Early', injectors:'DI', trans:'Varies', screen:'3.5" Handheld' },
    screen: { sku:'550-1623', vid:51418558136614, price:2834.95, handle:'550-1623' },
    noscreen: null
  },
  'lt-lt4-late-max': {
    name: 'Terminator X Max - Gen V LT4 Late',
    desc: 'Gen V LT4 supercharged engine, late connector.',
    specs: { engine:'Gen V LT4 Late', injectors:'DI', trans:'Varies', screen:'3.5" Handheld' },
    screen: { sku:'550-1624', vid:51418558169382, price:2834.95, handle:'550-1624' },
    noscreen: null
  },
  'lt-lt4-early-max-trans': {
    name: 'Terminator X Max - Gen V LT4 Early + Trans',
    desc: 'Gen V LT4 early with transmission control.',
    specs: { engine:'Gen V LT4 Early', injectors:'DI', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-1633-6', vid:51418558234918, price:3284.95, handle:'550-1633-6' },
    noscreen: null
  },
  'lt-lt4-late-max-trans': {
    name: 'Terminator X Max - Gen V LT4 Late + Trans',
    desc: 'Gen V LT4 late with transmission control.',
    specs: { engine:'Gen V LT4 Late', injectors:'DI', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-1634-6', vid:51418558202150, price:3284.95, handle:'550-1634-6' },
    noscreen: null
  },

  /* ── Ford Coyote ────────────────────────────────────── */
  'ford-coyote_11_12_ev1-x': {
    name: 'Terminator X - Ford Coyote 2011-2012 EV1',
    desc: '2011-2012 Ford 5.0L Coyote with Ti-VCT variable cam timing. EV1 injector connector.',
    specs: { engine:'Coyote 2011-2012', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1210', vid:51418558365990, price:2717.95, handle:'550-1210' },
    noscreen: null
  },
  'ford-coyote_11_12_ev6-x': {
    name: 'Terminator X - Ford Coyote 2011-2012 EV6',
    desc: '2011-2012 Coyote with EV6 injector connector.',
    specs: { engine:'Coyote 2011-2012', injectors:'EV6', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1211', vid:51418558398758, price:2717.95, handle:'550-1211' },
    noscreen: null
  },
  'ford-coyote_13_15_ev1-x': {
    name: 'Terminator X - Ford Coyote 2013-2015 EV1',
    desc: '2013-2015 Coyote with EV1 injector connector.',
    specs: { engine:'Coyote 2013-2015', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1212', vid:51418558431526, price:2717.95, handle:'550-1212' },
    noscreen: null
  },
  'ford-coyote_13_15_ev6-x': {
    name: 'Terminator X - Ford Coyote 2013-2015 EV6',
    desc: '2013-2015 Coyote with EV6 injector connector.',
    specs: { engine:'Coyote 2013-2015', injectors:'EV6', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1213', vid:51418558464294, price:2717.95, handle:'550-1213' },
    noscreen: null
  },
  'ford-coyote_15_17_ev1-x': {
    name: 'Terminator X - Ford Coyote 2015.5-2017 EV1',
    desc: '2015.5-2017 Coyote (Gen 2) with EV1 injector connector.',
    specs: { engine:'Coyote 2015.5-2017', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1214', vid:51418558923046, price:2717.95, handle:'550-1214' },
    noscreen: null
  },
  'ford-coyote_15_17_ev6-x': {
    name: 'Terminator X - Ford Coyote 2015.5-2017 EV6',
    desc: '2015.5-2017 Coyote (Gen 2) with EV6 injector connector.',
    specs: { engine:'Coyote 2015.5-2017', injectors:'EV6', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1215', vid:51418558955814, price:2717.95, handle:'550-1215' },
    noscreen: null
  },
  /* Coyote X Max */
  'ford-coyote_13_15_ev6-max-trans': {
    name: 'Terminator X Max - Ford Coyote 2013-2015 EV6 + Trans',
    desc: '2013-2015 Coyote with EV6 injectors and Ford 4R70W transmission control.',
    specs: { engine:'Coyote 2013-2015', injectors:'EV6', trans:'4R70W', screen:'3.5" Handheld' },
    screen: { sku:'550-1312', vid:51418551681318, price:3014.95, handle:'550-1312' },
    noscreen: null
  },
  'ford-coyote_13_15_ev6b-max-trans': {
    name: 'Terminator X Max - Ford Coyote 2013-2015 EV6 + Trans (B)',
    desc: '2013-2015 Coyote alternative with EV6 and 4R70W.',
    specs: { engine:'Coyote 2013-2015', injectors:'EV6', trans:'4R70W', screen:'3.5" Handheld' },
    screen: { sku:'550-1313', vid:51418551648550, price:3014.95, handle:'550-1313' },
    noscreen: null
  },
  'ford-coyote_15_17_ev6-max-trans': {
    name: 'Terminator X Max - Ford Coyote 2015.5-2017 EV6 + Trans',
    desc: '2015.5-2017 Coyote with EV6 and 4R70W trans control.',
    specs: { engine:'Coyote 2015.5-2017', injectors:'EV6', trans:'4R70W', screen:'3.5" Handheld' },
    screen: { sku:'550-1315', vid:51418551714086, price:3014.95, handle:'550-1315' },
    noscreen: null
  },
  'ford-coyote_11_12-max-dbw': {
    name: 'Terminator X Max - Ford Coyote 2011-2012 DBW',
    desc: '2011-2012 Coyote with drive-by-wire control and EV6.',
    specs: { engine:'Coyote 2011-2012', injectors:'EV6', trans:'DBW only', screen:'3.5" Handheld' },
    screen: { sku:'550-1409', vid:51418551386406, price:3014.95, handle:'550-1409' },
    noscreen: null
  },
  'ford-coyote_13_15-max-dbw': {
    name: 'Terminator X Max - Ford Coyote 2013-2015 DBW',
    desc: '2013-2015 Coyote with DBW and EV6.',
    specs: { engine:'Coyote 2013-2015', injectors:'EV6', trans:'DBW only', screen:'3.5" Handheld' },
    screen: { sku:'550-1411', vid:51418551451942, price:3014.95, handle:'550-1411' },
    noscreen: null
  },
  'ford-coyote_15_17_ev1-max-dbw': {
    name: 'Terminator X Max - Ford Coyote 2015.5-2017 EV1 + DBW',
    desc: '2015.5-2017 Coyote with DBW and EV1.',
    specs: { engine:'Coyote 2015.5-2017', injectors:'EV1', trans:'DBW only', screen:'3.5" Handheld' },
    screen: { sku:'550-1412', vid:51418552205606, price:3014.95, handle:'550-1412' },
    noscreen: null
  },
  'ford-coyote_15_17_ev6-max-dbw': {
    name: 'Terminator X Max - Ford Coyote 2015.5-2017 EV6 + DBW',
    desc: '2015.5-2017 Coyote with DBW and EV6.',
    specs: { engine:'Coyote 2015.5-2017', injectors:'EV6', trans:'DBW only', screen:'3.5" Handheld' },
    screen: { sku:'550-1413', vid:51418552238374, price:3014.95, handle:'550-1413' },
    noscreen: null
  },
  'ford-coyote_11_12-max-trans-dbw': {
    name: 'Terminator X Max - Ford Coyote 2011-2012 + Trans + DBW',
    desc: '2011-2012 Coyote with 4R70W trans and DBW.',
    specs: { engine:'Coyote 2011-2012', injectors:'EV6', trans:'4R70W + DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-1508', vid:51418551419174, price:3014.95, handle:'550-1508' },
    noscreen: null
  },
  'ford-coyote_13_15-max-trans-dbw': {
    name: 'Terminator X Max - Ford Coyote 2013-2015 + Trans + DBW',
    desc: '2013-2015 Coyote with 4R70W trans and DBW.',
    specs: { engine:'Coyote 2013-2015', injectors:'EV6', trans:'4R70W + DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-1510', vid:51418551484710, price:3014.95, handle:'550-1510' },
    noscreen: null
  },
  'ford-coyote_15_17-max-trans-dbw': {
    name: 'Terminator X Max - Ford Coyote 2015.5-2017 + Trans + DBW',
    desc: '2015.5-2017 Coyote with 4R70W trans and DBW.',
    specs: { engine:'Coyote 2015.5-2017', injectors:'EV6', trans:'4R70W + DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-1512', vid:51418552402214, price:3014.95, handle:'550-1512' },
    noscreen: null
  },

  /* ── Ford Modular 4.6/5.4 ───────────────────────────── */
  'ford-mod_2v_ev1-max-trans': {
    name: 'Terminator X Max - Ford Modular 2V EV1 + Trans',
    desc: '4.6/5.4L 2-valve modular Ford (SOHC). Stock coils, EV1 connectors, 4R70W trans control.',
    specs: { engine:'Modular 4.6/5.4 2V', injectors:'EV1', trans:'4R70W', screen:'3.5" Handheld' },
    screen: { sku:'550-1316', vid:51418552664358, price:1862.05, handle:'550-1316' },
    noscreen: null
  },
  'ford-mod_2v_ev6-max-trans': {
    name: 'Terminator X Max - Ford Modular 2V EV6 + Trans',
    desc: '4.6/5.4L 2V with stock coils, EV6 connectors, 4R70W trans control.',
    specs: { engine:'Modular 4.6/5.4 2V', injectors:'EV6', trans:'4R70W', screen:'3.5" Handheld' },
    screen: { sku:'550-1317', vid:51418552697126, price:1862.05, handle:'550-1317' },
    noscreen: null
  },
  'ford-mod_4v_ev1-max-trans': {
    name: 'Terminator X Max - Ford Modular 4V EV1 + Trans',
    desc: '4.6/5.4L 4-valve modular Ford (DOHC - Cobra, GT500 etc). EV1, 4R70W trans.',
    specs: { engine:'Modular 4.6/5.4 4V', injectors:'EV1', trans:'4R70W', screen:'3.5" Handheld' },
    screen: { sku:'550-1318', vid:51418553418022, price:1862.05, handle:'550-1318' },
    noscreen: null
  },
  'ford-mod_4v_ev6-max-trans': {
    name: 'Terminator X Max - Ford Modular 4V EV6 + Trans',
    desc: '4.6/5.4L 4V with EV6 connectors and 4R70W trans control.',
    specs: { engine:'Modular 4.6/5.4 4V', injectors:'EV6', trans:'4R70W', screen:'3.5" Handheld' },
    screen: { sku:'550-1319', vid:51418553450790, price:1862.05, handle:'550-1319' },
    noscreen: null
  },

  /* ── Ford Foxbody 5.0 ───────────────────────────────── */
  'ford-foxbody-x': {
    name: 'Terminator X - Ford Foxbody 5.0 (1979-1993)',
    desc: '1979-1993 Ford Mustang 5.0 HO. Includes ECU bracket, TFI ignition adapter and Foxbody-specific harness.',
    specs: { engine:'Foxbody 5.0 HO', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-937F', vid:51418558300454, price:1254.56, handle:'550-937f' },
    noscreen: null
  },

  /* ── Ford Godzilla 7.3L ─────────────────────────────── */
  'ford-godzilla-max': {
    name: 'Terminator X Max - Ford Godzilla 7.3L',
    desc: 'Ford 7.3L Godzilla V8 (2020+). Terminator X Max with full engine management.',
    specs: { engine:'Ford 7.3L Godzilla', injectors:'OEM', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1431', vid:51418556334374, price:1699.95, handle:'550-1431' },
    noscreen: null
  },

  /* ── Chrysler Gen III HEMI ──────────────────────────── */
  'hemi-hemi_03_06-x': {
    name: 'Terminator X - Gen III HEMI 2003-2006',
    desc: '5.7L, 6.1L HEMI without VVT (2003-2006). Includes EV1 harness.',
    specs: { engine:'HEMI 2003-2006', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1223', vid:51418558562598, price:1578.56, handle:'550-1223' },
    noscreen: null
  },
  'hemi-hemi_07_13_vvt-x': {
    name: 'Terminator X - Gen III HEMI 2007-2013+ VVT',
    desc: '5.7L HEMI with variable valve timing (2007-2013+). Requires VVT harness add-on.',
    specs: { engine:'HEMI 2007-2013+ VVT', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1224', vid:51418558595366, price:1754.96, handle:'550-1224' },
    noscreen: null
  },
  'hemi-hemi_07_13_nov-x': {
    name: 'Terminator X - Gen III HEMI 2007-2013+ Non-VVT',
    desc: '6.1L, 6.4L SRT HEMI without VVT (2007-2013+).',
    specs: { engine:'HEMI 2007-2013+ Non-VVT', injectors:'EV1', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1225', vid:51418558628134, price:1578.56, handle:'550-1225' },
    noscreen: null
  },
  /* HEMI X Max */
  'hemi-hemi_03_06_ev1-max': {
    name: 'Terminator X Max - Gen III HEMI 2003-2006 EV1 + DBW',
    desc: '2003-2006 HEMI with drive-by-wire and EV1 injectors.',
    specs: { engine:'HEMI 2003-2006', injectors:'EV1', trans:'DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-1420', vid:51418552140070, price:2069.95, handle:'550-1420' },
    noscreen: null
  },
  'hemi-hemi_03_06_ev6-max': {
    name: 'Terminator X Max - Gen III HEMI 2003-2006 EV6 + DBW',
    desc: '2003-2006 HEMI with drive-by-wire and EV6 injectors.',
    specs: { engine:'HEMI 2003-2006', injectors:'EV6', trans:'DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-1421', vid:51418552172838, price:1862.05, handle:'550-1421' },
    noscreen: null
  },
  'hemi-hemi_07_12_ev1-max': {
    name: 'Terminator X Max - Gen III HEMI 2007-2012 EV1 + DBW',
    desc: '2007-2012 HEMI with drive-by-wire and EV1.',
    specs: { engine:'HEMI 2007-2012', injectors:'EV1', trans:'DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-1422', vid:51418552434982, price:2069.95, handle:'550-1422' },
    noscreen: null
  },
  'hemi-hemi_07_12_ev6-max': {
    name: 'Terminator X Max - Gen III HEMI 2007-2012 EV6 + DBW',
    desc: '2007-2012 HEMI with DBW and EV6.',
    specs: { engine:'HEMI 2007-2012', injectors:'EV6', trans:'DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-1423', vid:51418552598822, price:1862.05, handle:'550-1423' },
    noscreen: null
  },
  'hemi-hemi_13plus_ev1-max': {
    name: 'Terminator X Max - Gen III HEMI 2013+ EV1 + DBW',
    desc: '2013+ HEMI with DBW and EV1.',
    specs: { engine:'HEMI 2013+', injectors:'EV1', trans:'DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-1424', vid:51418552467750, price:1862.05, handle:'550-1424' },
    noscreen: null
  },
  'hemi-hemi_13plus_ev6-max': {
    name: 'Terminator X Max - Gen III HEMI 2013+ EV6 + DBW',
    desc: '2013+ HEMI with DBW and EV6.',
    specs: { engine:'HEMI 2013+', injectors:'EV6', trans:'DBW', screen:'3.5" Handheld' },
    screen: { sku:'550-1425', vid:51418552631590, price:1862.05, handle:'550-1425' },
    noscreen: null
  },

  /* ── Stealth TBI — 4150 4-injector ─────────────────── */
  'stealth-s4150_4inj-x': {
    name: 'Terminator X Stealth 4150 - 4 Injector',
    desc: 'Carburettor-replacement EFI with carb-style air cleaner housing. Holley 4150 flange, 4 x 100 lb/hr injectors, up to 650hp N/A. Includes full Terminator X ECU and 3.5" handheld.',
    specs: { engine:'Any (carb replacement)', injectors:'4 x 100 lb/hr', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1002', vid:51418559185190, price:1619.06, handle:'550-1002' },
    noscreen: null,
    colours: [
      { label:'Black', dot:'#1a1a1a', sku:'550-1002', vid:51418559185190, price:1619.06, handle:'550-1002' },
      { label:'Shiny', dot:'#d4d4d4', sku:'550-1001', vid:52170992845094, price:1619.06, handle:'550-1002' },
      { label:'Gold',  dot:'#c9a84c', sku:'550-1003', vid:52170992877862, price:1619.06, handle:'550-1002' }
    ]
  },
  'stealth-s4150_4inj-max-trans': {
    name: 'Terminator X Max Stealth 4150 - 4 Injector + Trans',
    desc: 'Stealth carb-look housing with Terminator X Max ECU. Adds GM 4L60E/4L80E transmission control.',
    specs: { engine:'Any (carb replacement)', injectors:'4 x 100 lb/hr', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-1012', vid:51418551124262, price:1943.05, handle:'550-1012' },
    noscreen: null,
    colours: [
      { label:'Black', dot:'#1a1a1a', sku:'550-1012', vid:51418551124262, price:1943.05, handle:'550-1012' },
      { label:'Shiny', dot:'#d4d4d4', sku:'550-1011', vid:52170993041702, price:1943.05, handle:'550-1012' },
      { label:'Gold',  dot:'#c9a84c', sku:'550-1013', vid:52170993074470, price:1943.05, handle:'550-1012' }
    ]
  },
  'stealth-s4150_4inj_ls24x-x': {
    name: 'Terminator X Stealth 4150 - GM LS 24x',
    desc: 'Stealth housing with LS-specific harness for GM LS engines with 24x crank reluctor.',
    specs: { engine:'GM LS 24x crank', injectors:'4 x 100 lb/hr', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1021', vid:51418559611174, price:2023.95, handle:'550-1021' },
    noscreen: null,
    colours: [
      { label:'Black', dot:'#1a1a1a', sku:'550-1021', vid:51418559611174, price:2023.95, handle:'550-1021' },
      { label:'Shiny', dot:'#d4d4d4', sku:'550-1020', vid:52170992910630, price:1862.05, handle:'550-1021' },
      { label:'Gold',  dot:'#c9a84c', sku:'550-1022', vid:52170992943398, price:2069.95, handle:'550-1021' }
    ]
  },
  'stealth-s4150_4inj_ls24x-max-trans': {
    name: 'Terminator X Max Stealth 4150 - GM LS 24x + Trans',
    desc: 'LS 24x Stealth kit with Terminator X Max and GM transmission control.',
    specs: { engine:'GM LS 24x crank', injectors:'4 x 100 lb/hr', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-1029', vid:51418560069926, price:2283.26, handle:'550-1029' },
    noscreen: null,
    colours: [
      { label:'Black', dot:'#1a1a1a', sku:'550-1029', vid:51418560069926, price:2283.26, handle:'550-1029' },
      { label:'Shiny', dot:'#d4d4d4', sku:'550-1028', vid:51418560135462, price:2283.26, handle:'550-1028' },
      { label:'Gold',  dot:'#c9a84c', sku:'550-1030', vid:51418560102694, price:2283.26, handle:'550-1030' }
    ]
  },
  'stealth-s4150_4inj_ls58x-x': {
    name: 'Terminator X Stealth 4150 - GM LS 58x',
    desc: 'Stealth housing with LS-specific harness for GM LS engines with 58x crank reluctor (LS2/LS3/Gen IV).',
    specs: { engine:'GM LS 58x crank', injectors:'4 x 100 lb/hr', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1061', vid:51418559709478, price:1862.05, handle:'550-1061' },
    noscreen: null,
    colours: [
      { label:'Black', dot:'#1a1a1a', sku:'550-1061', vid:51418559709478, price:1862.05, handle:'550-1061' },
      { label:'Shiny', dot:'#d4d4d4', sku:'550-1060', vid:52170992976166, price:2069.95, handle:'550-1061' },
      { label:'Gold',  dot:'#c9a84c', sku:'550-1062', vid:52170993008934, price:1862.05, handle:'550-1061' }
    ]
  },
  'stealth-s4150_4inj_ls58x-max-trans': {
    name: 'Terminator X Max Stealth 4150 - GM LS 58x + Trans',
    desc: 'LS 58x Stealth kit with transmission control.',
    specs: { engine:'GM LS 58x crank', injectors:'4 x 100 lb/hr', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-1064', vid:51418560168230, price:2537.95, handle:'550-1064' },
    noscreen: null,
    colours: [
      { label:'Black', dot:'#1a1a1a', sku:'550-1064', vid:51418560168230, price:2537.95, handle:'550-1064' },
      { label:'Shiny', dot:'#d4d4d4', sku:'550-1063', vid:51418560233766, price:2283.26, handle:'550-1063' },
      { label:'Gold',  dot:'#c9a84c', sku:'550-1065', vid:51418560200998, price:2283.26, handle:'550-1065' }
    ]
  },
  'stealth-s4150_8inj-x': {
    name: 'Terminator X Stealth 4150 - 8 Injector (High Power)',
    desc: '8-injector Stealth 4150 for high-power builds up to 1,250hp. Larger capacity than the 4-injector version.',
    specs: { engine:'Any (carb replacement)', injectors:'8 x injectors', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1005', vid:51418559283494, price:2032.15, handle:'550-1005' },
    noscreen: null
  },
  'stealth-s4150_8inj-max-trans': {
    name: 'Terminator X Max Stealth 4150 - 8 Injector + Trans',
    desc: '8-injector Stealth 4150 with transmission control.',
    specs: { engine:'Any (carb replacement)', injectors:'8 x injectors', trans:'4L60E/4L80E', screen:'3.5" Handheld' },
    screen: { sku:'550-1015', vid:51418551222566, price:2283.26, handle:'550-1015' },
    noscreen: null
  },
  'stealth-s4150_2x4-x': {
    name: 'Terminator X Stealth 4150 - 2x4 Dual Carb',
    desc: 'Dual 4150-flange throttle body setup for tunnel ram or dual quad intakes. 1,500hp+ capability.',
    specs: { engine:'Dual 4150 intake', injectors:'2 x 4 injectors', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1074', vid:51418559021350, price:2550.55, handle:'550-1074' },
    noscreen: null
  },
  'stealth-s4500_8inj-x': {
    name: 'Terminator X Stealth 4500 - 8 Injector Dominator',
    desc: 'Holley 4500 Dominator flange. 8-injector for large-cubic-inch or boosted engines up to 1,500hp.',
    specs: { engine:'Any (4500 Dominator)', injectors:'8 x injectors', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1071', vid:51418559316262, price:2364.26, handle:'550-1071' },
    noscreen: null
  },
  'stealth-s4500_2x4-x': {
    name: 'Terminator X Stealth 4500 - 2x4 Dual Dominator',
    desc: 'Dual 4500 Dominator flange setup for maximum power applications.',
    specs: { engine:'Dual 4500 intake', injectors:'2 x 4 injectors', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-1081', vid:51418560004390, price:3036.55, handle:'550-1081' },
    noscreen: null
  },

  /* ── Universal MPFI ─────────────────────────────────── */
  'universal-universal-x': {
    name: 'Terminator X Universal MPFI',
    desc: 'Universal MPFI main harness for custom engine applications. You supply your own manifold harness and coil drivers.',
    specs: { engine:'Universal / Custom', injectors:'Customer supplied', trans:'Not included', screen:'3.5" Handheld' },
    screen: { sku:'550-936', vid:51418558333222, price:1214.06, handle:'550-936' },
    noscreen: null
  },

  /* ── Stealth TB Only (534-xxx) ─────────────────────────────────── */
  'stealth-s4150_4inj-tb-only': {
    name: 'Terminator X Stealth 4150 - Throttle Body Only (4 Injector)',
    desc: 'Stealth 4150 throttle body with 4 x 100 lb/hr injectors. No ECU included - designed for use with an existing external Terminator X ECU and harness.',
    specs: { engine:'Any (carb replacement)', injectors:'4 x 100 lb/hr', trans:'Use existing ECU', screen:'External ECU required' },
    screen: { sku:'534-293', vid:51418559480102, price:1484.96, handle:'534-293' },
    noscreen: null,
    colours: [
      { label:'Black', dot:'#1a1a1a', sku:'534-293', vid:51418559480102, price:1484.96, handle:'534-293' },
      { label:'Gold',  dot:'#c9a84c', sku:'534-294', vid:51418559512870, price:1484.96, handle:'534-294' }
    ]
  },
  'stealth-s4150_8inj-tb-only': {
    name: 'Terminator X Stealth 4150 - Throttle Body Only (8 Injector)',
    desc: 'Stealth 4150 throttle body with 8 injectors for high-power builds up to 1,250hp. No ECU included - for use with an existing Terminator X ECU.',
    specs: { engine:'Any (carb replacement)', injectors:'8 injectors', trans:'Use existing ECU', screen:'External ECU required' },
    screen: { sku:'534-296', vid:51418559578406, price:1754.96, handle:'534-296' },
    noscreen: null
  },
  'stealth-s4500_8inj-tb-only': {
    name: 'Terminator X Stealth 4500 - Throttle Body Only (8 Injector)',
    desc: 'Stealth 4500 Dominator throttle body, 8 injectors, up to 1,500hp. No ECU - use with existing Terminator X ECU.',
    specs: { engine:'Any (4500 Dominator)', injectors:'8 injectors', trans:'Use existing ECU', screen:'External ECU required' },
    screen: { sku:'534-302', vid:51418559938854, price:2167.15, handle:'534-302' },
    noscreen: null
  },

  /* ── Terminator LS (Legacy) ─────────────────────────────────────── */
  'termls-ls_gen4-full': {
    name: 'Terminator LS - LS2/LS3 58x DBW + Trans Control',
    desc: 'Original Terminator LS complete harness kit for LS2/LS3 and Gen IV 4.8/5.3/6.0 truck engines. Includes drive-by-wire throttle body control, 4L60E/4L80E transmission control and EV6 injector harness. Full standalone engine management.',
    specs: { engine:'LS2/LS3/Gen IV 58x', injectors:'EV6', trans:'4L60E/4L80E + DBW', screen:'3.5" Handheld Included' },
    screen: { sku:'550-613', vid:50558781948198, price:3913.95, handle:'550-613' },
    noscreen: null
  },
  'termls-ls_gen3_truck-no-dbw': {
    name: 'Terminator LS - Gen III Truck 24x (No DBW)',
    desc: 'Terminator LS kit for 4.8/5.3/6.0 Gen III truck engines with 24x crank. No drive-by-wire. Traditional throttle cable setup.',
    specs: { engine:'Gen III Truck 24x', injectors:'EV1/Multec 2', trans:'Not included', screen:'3.5" Handheld Included' },
    screen: { sku:'550-614', vid:50558782112038, price:2473.95, handle:'550-614' },
    noscreen: null
  },
  'termls-ls_gen3_dbw-dbw': {
    name: 'Terminator LS - Gen III Truck 24x DBW + Trans',
    desc: 'Terminator LS kit for Gen III truck engines with drive-by-wire throttle body and 4L60E/4L80E transmission control.',
    specs: { engine:'Gen III Truck 24x', injectors:'EV1/Multec 2', trans:'4L60E/4L80E + DBW', screen:'3.5" Handheld Included' },
    screen: { sku:'550-615', vid:50558782603558, price:4049.95, handle:'550-615' },
    noscreen: null
  },
};

/* ══════════════════════════════════════════════════════
   SELECTOR TREE — defines the step 2 options per family
   ══════════════════════════════════════════════════════ */

var SPEC_OPTS = {
  ls_gen3: {
    q: 'Which LS1/Gen III variant?',
    hint: 'LS1/LS6 use the standard LS harness. Gen III truck engines (4.8/5.3/6.0 with 24x crank) use a different harness with Multec 2 injector connectors.',
    opts: [
      { id:'ls1_ev1',   label:'LS1 / LS6',           sub:'EV1 (Bosch) injector connector', icon:'⚙️' },
      { id:'ls1_ev6',   label:'LS1 / LS6',           sub:'EV6 (USCAR) injector connector', icon:'⚙️' },
      { id:'truck_ev1', label:'Gen III Truck 4.8/5.3/6.0', sub:'24x crank, Multec 2/EV1 connectors', icon:'🚛' }
    ]
  },
  ls_gen4: {
    q: 'Which LS2/Gen IV variant?',
    hint: 'All Gen IV engines use 58x crank reluctor. Choose your injector connector type - EV1 (Bosch) or EV6 (USCAR/later style).',
    opts: [
      { id:'ls2_ev1', label:'LS2 / LS3 / LS7 / Gen IV Truck', sub:'EV1 (Bosch) injector connector', icon:'⚙️' },
      { id:'ls2_ev6', label:'LS2 / LS3 / LS7 / Gen IV Truck', sub:'EV6 (USCAR) injector connector', icon:'⚙️' }
    ]
  },
  lt: {
    q: 'Which Gen V LT engine?',
    hint: 'LT engines use direct injection - the ECU controls both the high-pressure direct injectors and the low-pressure port injectors. Early and late refer to the engine connector pinout, not model year.',
    opts: [
      { id:'early', label:'LT1 / L83 / L86 Early',  sub:'2014-2019 LT1, early connector pinout', icon:'🔬' },
      { id:'late',  label:'LT1 / L84 / L87 Late',   sub:'2020+ LT1, late connector pinout', icon:'🔬' },
      { id:'lt4',   label:'LT4 Supercharged',        sub:'6.2L supercharged - Corvette Z06, Camaro ZL1', icon:'💥', tag:'High Power' }
    ]
  },
  ford: {
    q: 'Which Ford engine?',
    hint: 'Select your specific Ford engine family. Coyote kits are year-specific due to changes in the VCT system.',
    opts: [
      { id:'coyote_11_12', label:'Coyote 5.0 2011-2012',     sub:'Gen 1 Ti-VCT, Mustang GT / F-150', icon:'🦅' },
      { id:'coyote_13_15', label:'Coyote 5.0 2013-2015',     sub:'Gen 1.5 Ti-VCT revised', icon:'🦅' },
      { id:'coyote_15_17', label:'Coyote 5.0 2015.5-2017',   sub:'Gen 2 Ti-VCT, Mustang GT', icon:'🦅' },
      { id:'mod_2v',       label:'Modular 4.6/5.4 2V',       sub:'SOHC - 1996-2004 Mustang GT, F-150', icon:'🔧' },
      { id:'mod_4v',       label:'Modular 4.6/5.4 4V',       sub:'DOHC Cobra, Mach 1, GT500 - 1996-2004', icon:'🔧' },
      { id:'foxbody',      label:'Foxbody 5.0 HO 1979-1993', sub:'Windsor 302 - classic Mustang', icon:'🐎', tag:'Classic' },
      { id:'godzilla',     label:'Godzilla 7.3L V8',         sub:'2020+ F-Series, Bronco', icon:'🦕', tag:'New' }
    ]
  },
  hemi: {
    q: 'Which HEMI generation?',
    hint: 'The Gen III HEMI changed significantly in 2007 with the addition of Multi-Displacement System (MDS) and variable valve timing on some models.',
    opts: [
      { id:'hemi_03_06',  label:'Gen III HEMI 2003-2006', sub:'5.7L, 6.1L - no VVT', icon:'🔴' },
      { id:'hemi_07_13',  label:'Gen III HEMI 2007-2013', sub:'5.7L with VVT or 6.1L/6.4L SRT non-VVT', icon:'🔴' },
      { id:'hemi_13plus', label:'Gen III HEMI 2013+',     sub:'6.4L SRT and later 5.7L', icon:'🔴' }
    ]
  },
  stealth: {
    q: 'Which Stealth TBI configuration?',
    hint: 'The Stealth uses a traditional carburettor-style housing with Terminator X EFI inside. Choose your flange type and injector count to match your intake manifold.',
    opts: [
      { id:'s4150_4inj',       label:'Stealth 4150 - 4 Injector',       sub:'Holley 4150 flange, up to 650hp N/A', icon:'🥷' },
      { id:'s4150_4inj_ls24x', label:'Stealth 4150 - GM LS 24x',        sub:'LS-specific harness, 24x crank', icon:'🥷', tag:'LS Specific' },
      { id:'s4150_4inj_ls58x', label:'Stealth 4150 - GM LS 58x',        sub:'LS-specific harness, 58x crank', icon:'🥷', tag:'LS Specific' },
      { id:'s4150_8inj',       label:'Stealth 4150 - 8 Injector',       sub:'4150 flange, up to 1,250hp', icon:'💪', tag:'High Power' },
      { id:'s4150_2x4',        label:'Stealth 4150 - 2x4 Dual',         sub:'Dual 4150 tunnel ram / dual quad', icon:'⚡', tag:'1,500hp+' },
      { id:'s4500_8inj',       label:'Stealth 4500 - 8 Injector',       sub:'Dominator 4500 flange, up to 1,500hp', icon:'💥', tag:'Dominator' },
      { id:'s4500_2x4',        label:'Stealth 4500 - 2x4 Dual',         sub:'Dual 4500 Dominator setup', icon:'🚀', tag:'Max Power' }
    ]
  },
  universal: {
    q: null, // auto-advance — only one option
    opts: [{ id:'universal', label:'Universal MPFI', sub:'', icon:'🔧' }]
  },
  termls: {
    q: 'Which Terminator LS kit?',
    hint: 'The original Terminator LS pre-dates Terminator X. These are complete plug-and-play kits for LS engines with full DBW and trans control capability.',
    opts: [
      { id:'ls_gen4',       label:'LS2/LS3 58x - DBW + Trans',       sub:'Gen IV LS2/LS3 with drive-by-wire and 4L60E/4L80E trans control', icon:'⚙️', tag:'Full Package' },
      { id:'ls_gen3_truck', label:'Gen III Truck 24x - No DBW',       sub:'4.8/5.3/6.0 truck, 24x crank, no drive-by-wire', icon:'🚛' },
      { id:'ls_gen3_dbw',   label:'Gen III Truck 24x - DBW + Trans',  sub:'4.8/5.3/6.0 truck with DBW and 4L60E/4L80E trans control', icon:'🚛', tag:'Full Package' }
    ]
  }
};

/* Feature options per spec - which features are available */
var FEATURE_OPTS = {
  /* LS Gen III — LS1/LS6 EV1 */
  'ls_gen3-ls1_ev1': [
    { id:'x',              label:'Terminator X',               sub:'Engine management only', icon:'🎛️' },
    { id:'max-trans',      label:'X Max + Trans Control',       sub:'Adds 4L60E/4L80E auto trans control', icon:'⚙️', tag:'Most Popular' },
    { id:'max-dbw',        label:'X Max + Drive-By-Wire',       sub:'DBW throttle body control, no trans', icon:'🔧' },
    { id:'max-trans-dbw',  label:'X Max + Trans + DBW',         sub:'Full control - trans and DBW combined', icon:'🏆', tag:'Full Package' },
    { id:'max-only',       label:'X Max (ECU only)',            sub:'Max ECU features, no trans or DBW', icon:'📦' }
  ],
  'ls_gen3-truck_ev1': [
    { id:'x',              label:'Terminator X',               sub:'Engine management only', icon:'🎛️' },
    { id:'max-trans',      label:'X Max + Trans Control',       sub:'Adds 4L60E/4L80E auto trans control', icon:'⚙️', tag:'Most Popular' },
    { id:'max-dbw',        label:'X Max + Drive-By-Wire',       sub:'DBW throttle body, no trans', icon:'🔧' },
    { id:'max-trans-dbw',  label:'X Max + Trans + DBW',         sub:'Trans and DBW combined', icon:'🏆', tag:'Full Package' }
  ],
  'ls_gen3-ls1_ev6': [
    { id:'x',              label:'Terminator X',               sub:'Engine management only', icon:'🎛️' },
    { id:'max-trans',      label:'X Max + Trans Control',       sub:'Adds 4L60E/4L80E auto trans control', icon:'⚙️', tag:'Most Popular' },
    { id:'max-dbw',        label:'X Max + Drive-By-Wire',       sub:'DBW throttle body, no trans', icon:'🔧' }
  ],
  /* LS Gen IV */
  'ls_gen4-ls2_ev1': [
    { id:'x', label:'Terminator X', sub:'Engine management only', icon:'🎛️' }
  ],
  'ls_gen4-ls2_ev6': [
    { id:'x',             label:'Terminator X',               sub:'Engine management only', icon:'🎛️' },
    { id:'max-trans',     label:'X Max + Trans Control',       sub:'Adds 4L60E/4L80E trans control', icon:'⚙️', tag:'Most Popular' },
    { id:'max-dbw',       label:'X Max + Drive-By-Wire',       sub:'DBW throttle body, no trans', icon:'🔧' },
    { id:'max-trans-dbw', label:'X Max + Trans + DBW',         sub:'Trans and DBW combined', icon:'🏆', tag:'Full Package' },
    { id:'max-only',      label:'X Max (ECU only)',            sub:'Max ECU, no trans or DBW', icon:'📦' }
  ],
  /* Gen V LT */
  'lt-early': [
    { id:'x',             label:'Terminator X',               sub:'Engine management only', icon:'🎛️' },
    { id:'max-trans',     label:'X Max + Trans Control',       sub:'Adds 4L60E/4L80E trans control', icon:'⚙️' },
    { id:'max-dbw-lt',    label:'X Max + DBW (LT Throttle Body)', sub:'LT-style drive-by-wire TB', icon:'🔧' },
    { id:'max-dbw-ls',    label:'X Max + DBW (LS Throttle Body)', sub:'LS-style DBW TB - common for swaps', icon:'🔧', tag:'Swap Friendly' },
    { id:'max-trans-dbw-lt', label:'X Max + Trans + DBW (LT TB)', sub:'Trans and LT DBW TB', icon:'🏆' },
    { id:'max-trans-dbw-ls', label:'X Max + Trans + DBW (LS TB)', sub:'Trans and LS DBW TB', icon:'🏆', tag:'Full Package' }
  ],
  'lt-late': [
    { id:'x',             label:'Terminator X',               sub:'Engine management only', icon:'🎛️' },
    { id:'max-trans',     label:'X Max + Trans Control',       sub:'Adds 4L60E/4L80E trans control', icon:'⚙️' },
    { id:'max-dbw-lt',    label:'X Max + DBW (LT Throttle Body)', sub:'LT-style drive-by-wire TB', icon:'🔧' },
    { id:'max-trans-dbw-lt', label:'X Max + Trans + DBW (LT TB)', sub:'Trans and LT DBW TB', icon:'🏆' },
    { id:'max-trans-dbw-ls', label:'X Max + Trans + DBW (LS TB)', sub:'Trans and LS DBW TB', icon:'🏆', tag:'Swap Friendly' }
  ],
  'lt-lt4': [
    { id:'x',         label:'Terminator X Max - LT4',  sub:'Engine management only', icon:'💥' },
    { id:'max-trans', label:'X Max - LT4 + Trans',      sub:'Adds 4L60E/4L80E trans control', icon:'⚙️' }
  ],
  /* Ford Coyote */
  'ford-coyote_11_12': [
    { id:'x-ev1',         label:'Terminator X (EV1)',   sub:'Engine management, EV1 injector connector', icon:'🎛️' },
    { id:'x-ev6',         label:'Terminator X (EV6)',   sub:'Engine management, EV6 injector connector', icon:'🎛️' },
    { id:'max-dbw',       label:'X Max + DBW',          sub:'Drive-by-wire throttle body', icon:'🔧' },
    { id:'max-trans-dbw', label:'X Max + Trans + DBW',  sub:'4R70W trans and DBW', icon:'🏆', tag:'Full Package' }
  ],
  'ford-coyote_13_15': [
    { id:'x-ev1',         label:'Terminator X (EV1)',   sub:'Engine management, EV1 injector connector', icon:'🎛️' },
    { id:'x-ev6',         label:'Terminator X (EV6)',   sub:'Engine management, EV6 injector connector', icon:'🎛️' },
    { id:'max-trans',     label:'X Max + Trans',        sub:'4R70W transmission control', icon:'⚙️' },
    { id:'max-dbw',       label:'X Max + DBW',          sub:'Drive-by-wire throttle body', icon:'🔧' },
    { id:'max-trans-dbw', label:'X Max + Trans + DBW',  sub:'4R70W trans and DBW', icon:'🏆', tag:'Full Package' }
  ],
  'ford-coyote_15_17': [
    { id:'x-ev1',         label:'Terminator X (EV1)',   sub:'Engine management, EV1 injector connector', icon:'🎛️' },
    { id:'x-ev6',         label:'Terminator X (EV6)',   sub:'Engine management, EV6 injector connector', icon:'🎛️' },
    { id:'max-trans',     label:'X Max + Trans',        sub:'4R70W transmission control', icon:'⚙️' },
    { id:'max-dbw-ev1',   label:'X Max + DBW (EV1)',    sub:'Drive-by-wire, EV1 connectors', icon:'🔧' },
    { id:'max-dbw-ev6',   label:'X Max + DBW (EV6)',    sub:'Drive-by-wire, EV6 connectors', icon:'🔧' },
    { id:'max-trans-dbw', label:'X Max + Trans + DBW',  sub:'4R70W trans and DBW', icon:'🏆', tag:'Full Package' }
  ],
  /* Ford Modular — only Max + Trans */
  'ford-mod_2v': [
    { id:'max-trans-ev1', label:'X Max + Trans (EV1 injectors)', sub:'Stock coils, EV1 Bosch connector - 4R70W trans', icon:'⚙️' },
    { id:'max-trans-ev6', label:'X Max + Trans (EV6 injectors)', sub:'Stock coils, EV6 USCAR connector - 4R70W trans', icon:'⚙️' }
  ],
  'ford-mod_4v': [
    { id:'max-trans-ev1', label:'X Max + Trans (EV1 injectors)', sub:'DOHC, EV1 Bosch connector - 4R70W trans', icon:'⚙️' },
    { id:'max-trans-ev6', label:'X Max + Trans (EV6 injectors)', sub:'DOHC, EV6 USCAR connector - 4R70W trans', icon:'⚙️' }
  ],
  /* Ford Foxbody — only X */
  'ford-foxbody': [
    { id:'x', label:'Terminator X', sub:'Engine management only - only available option', icon:'🎛️', tag:'Only Option' }
  ],
  /* Ford Godzilla — only Max */
  'ford-godzilla': [
    { id:'max', label:'Terminator X Max', sub:'Only available configuration for Godzilla 7.3L', icon:'🦕', tag:'Only Option' }
  ],
  /* HEMI */
  'hemi-hemi_03_06': [
    { id:'x',   label:'Terminator X',      sub:'Engine management only', icon:'🎛️' },
    { id:'max-ev1', label:'X Max + DBW (EV1)', sub:'Drive-by-wire with EV1 injectors', icon:'🔧' },
    { id:'max-ev6', label:'X Max + DBW (EV6)', sub:'Drive-by-wire with EV6 injectors', icon:'🔧' }
  ],
  'hemi-hemi_07_13': [
    { id:'vvt',     label:'Terminator X - VVT Engine',   sub:'2007+ 5.7L with variable valve timing', icon:'🎛️' },
    { id:'nov',     label:'Terminator X - Non-VVT',      sub:'6.1L, 6.4L SRT without VVT', icon:'🎛️' },
    { id:'max-ev1', label:'X Max + DBW (EV1)',            sub:'DBW with EV1 connectors', icon:'🔧' },
    { id:'max-ev6', label:'X Max + DBW (EV6)',            sub:'DBW with EV6 connectors', icon:'🔧' }
  ],
  'hemi-hemi_13plus': [
    { id:'max-ev1', label:'X Max + DBW (EV1)', sub:'Drive-by-wire with EV1 injectors', icon:'🔧' },
    { id:'max-ev6', label:'X Max + DBW (EV6)', sub:'Drive-by-wire with EV6 injectors', icon:'🔧' }
  ],
  /* Stealth */
  'stealth-s4150_4inj':       [{ id:'x', label:'Terminator X', sub:'Stealth carb-look EFI', icon:'🥷' }, { id:'max-trans', label:'X Max + Trans', sub:'Adds 4L60E/4L80E trans control', icon:'⚙️' }, { id:'tb-only', label:'Throttle Body Only', sub:'No ECU - use with existing Terminator X ECU', icon:'🔩' }],
  'stealth-s4150_4inj_ls24x': [{ id:'x', label:'Terminator X', sub:'LS 24x harness', icon:'🥷' }, { id:'max-trans', label:'X Max + Trans', sub:'Adds trans control', icon:'⚙️' }],
  'stealth-s4150_4inj_ls58x': [{ id:'x', label:'Terminator X', sub:'LS 58x harness', icon:'🥷' }, { id:'max-trans', label:'X Max + Trans', sub:'Adds trans control', icon:'⚙️' }],
  'stealth-s4150_8inj':       [{ id:'x', label:'Terminator X', sub:'8-injector, up to 1,250hp', icon:'💪' }, { id:'max-trans', label:'X Max + Trans', sub:'Adds trans control', icon:'⚙️' }, { id:'tb-only', label:'Throttle Body Only', sub:'No ECU - use with existing Terminator X ECU', icon:'🔩' }],
  'stealth-s4150_2x4':        [{ id:'x', label:'Terminator X', sub:'Dual 4150 setup', icon:'⚡' }],
  'stealth-s4500_8inj':       [{ id:'x', label:'Terminator X', sub:'4500 Dominator, 1,500hp', icon:'💥' }, { id:'tb-only', label:'Throttle Body Only', sub:'No ECU - use with existing Terminator X ECU', icon:'🔩' }],
  'stealth-s4500_2x4':        [{ id:'x', label:'Terminator X', sub:'Dual 4500 Dominator', icon:'🚀' }],
  /* Universal */
  'termls-ls_gen4':       [{ id:'full',   label:'Terminator LS - DBW + Trans', sub:'Only available configuration', icon:'⚙️', tag:'Only Option' }],
  'termls-ls_gen3_truck': [{ id:'no-dbw', label:'Terminator LS - No DBW',      sub:'Only available configuration', icon:'🚛', tag:'Only Option' }],
  'termls-ls_gen3_dbw':   [{ id:'dbw',    label:'Terminator LS - DBW + Trans', sub:'Only available configuration', icon:'⚙️', tag:'Only Option' }],
    'universal-universal': [
    { id:'x',         label:'Terminator X',       sub:'Universal MPFI, no trans', icon:'🎛️' },
    { id:'max-trans', label:'X Max + GM Trans',    sub:'Universal MPFI with GM trans control', icon:'⚙️' },
    { id:'max-ford',  label:'X Max + Ford Trans',  sub:'Universal MPFI with Ford 4R70W control', icon:'⚙️' }
  ]
};

/* Map feature selection to product key */
function getProductKey(family, spec, feature) {
  var base = family + '-' + spec + '-';
  /* Handle special cases */
  if (family === 'ford' && spec === 'godzilla') return 'ford-godzilla-max';
  if (family === 'hemi') {
    if (spec === 'hemi_07_13') {
      if (feature === 'vvt') return 'hemi-hemi_07_13_vvt-x';
      if (feature === 'nov') return 'hemi-hemi_07_13_nov-x';
      if (feature === 'max-ev1') return 'hemi-hemi_07_12_ev1-max';
      if (feature === 'max-ev6') return 'hemi-hemi_07_12_ev6-max';
    }
    if (spec === 'hemi_03_06') {
      if (feature === 'x') return 'hemi-hemi_03_06-x';
      if (feature === 'max-ev1') return 'hemi-hemi_03_06_ev1-max';
      if (feature === 'max-ev6') return 'hemi-hemi_03_06_ev6-max';
    }
    if (spec === 'hemi_13plus') {
      if (feature === 'max-ev1') return 'hemi-hemi_13plus_ev1-max';
      if (feature === 'max-ev6') return 'hemi-hemi_13plus_ev6-max';
    }
  }
  if (family === 'universal') {
    if (feature === 'x')         return 'universal-universal-x';
    if (feature === 'max-trans') return 'universal-universal-x'; // same kit, note difference
    if (feature === 'max-ford')  return 'universal-universal-x';
  }
  /* LT special cases */
  if (family === 'lt') {
    /* LT4 must be checked first as it uses different product keys */
    if (spec === 'lt4') {
      if (feature === 'x')         return 'lt-lt4-early-max';
      if (feature === 'max-trans') return 'lt-lt4-early-max-trans';
    }
    var k = 'lt-' + spec + '-';
    if (feature === 'x')              return k + 'x';
    if (feature === 'max-trans')      return k + 'max-trans';
    if (feature === 'max-dbw-lt')     return k + 'max-dbw-lt';
    if (feature === 'max-dbw-ls')     return k + 'max-dbw-ls';
    if (feature === 'max-trans-dbw-lt') return k + 'max-trans-dbw-lt';
    if (feature === 'max-trans-dbw-ls') return k + 'max-trans-dbw-ls';
  }
  /* LS Gen IV alt handling */
  if (family === 'ls_gen4' && spec === 'ls2_ev6') {
    if (feature === 'x')              return 'ls_gen4-ls2_ev6-x';
    if (feature === 'max-trans')      return 'ls_gen4-ls2_ev6-max-trans';
    if (feature === 'max-dbw')        return 'ls_gen4-ls2_ev6-max-dbw';
    if (feature === 'max-trans-dbw')  return 'ls_gen4-ls2_ev6-max-trans-dbw';
    if (feature === 'max-only')       return 'ls_gen4-ls2_ev6-max-only';
  }
  /* Ford — handle simple single-option specs first */
  if (family === 'ford') {
    if (spec === 'foxbody')  return 'ford-foxbody-x';
    if (spec === 'godzilla') return 'ford-godzilla-max';
    /* Modular */
    if (spec === 'mod_2v' || spec === 'mod_4v') {
      if (feature === 'max-trans-ev1') return 'ford-' + spec + '_ev1-max-trans';
      if (feature === 'max-trans-ev6') return 'ford-' + spec + '_ev6-max-trans';
      return 'ford-' + spec + '_ev1-max-trans';
    }
    /* Coyote — EV1/EV6 explicit */
    var cs = spec;
    if (feature === 'x-ev1')          return 'ford-' + cs + '_ev1-x';
    if (feature === 'x-ev6')          return 'ford-' + cs + '_ev6-x';
    if (feature === 'x')              return 'ford-' + cs + '_ev1-x';
    if (feature === 'max-trans')      return 'ford-' + cs + '_ev6-max-trans';
    if (feature === 'max-dbw')        return 'ford-' + cs + '-max-dbw';
    if (feature === 'max-dbw-ev1')    return 'ford-' + cs + '_ev1-max-dbw';
    if (feature === 'max-dbw-ev6')    return 'ford-' + cs + '_ev6-max-dbw';
    if (feature === 'max-trans-dbw')  return 'ford-' + cs + '-max-trans-dbw';
    if (feature === 'max-ev1')        return 'ford-' + cs + '_ev1-max-trans';
    if (feature === 'max-ev6')        return 'ford-' + cs + '_ev6-max-trans';
  }
  /* Stealth */
  if (family === 'stealth') {
    if (feature === 'x')         return 'stealth-' + spec + '-x';
    if (feature === 'max-trans') return 'stealth-' + spec + '-max-trans';
    if (feature === 'tb-only') {
      if (spec === 's4150_4inj' || spec === 's4150_4inj_ls24x' || spec === 's4150_4inj_ls58x') return 'stealth-s4150_4inj-tb-only';
      if (spec === 's4150_8inj') return 'stealth-s4150_8inj-tb-only';
      if (spec === 's4500_8inj') return 'stealth-s4500_8inj-tb-only';
    }
  }
  /* Terminator LS */
  if (family === 'termls') {
    if (spec === 'ls_gen4')       return 'termls-ls_gen4-full';
    if (spec === 'ls_gen3_truck') return 'termls-ls_gen3_truck-no-dbw';
    if (spec === 'ls_gen3_dbw')   return 'termls-ls_gen3_dbw-dbw';
  }
  /* Standard LS */
  var map = {
    'x': 'x', 'max-trans': 'max-trans', 'max-dbw': 'max-dbw',
    'max-trans-dbw': 'max-trans-dbw', 'max-only': 'max-only'
  };
  return family + '-' + spec + '-' + (map[feature] || feature);
}

/* ══════════════════════════════════════════════════════
   SELECTOR LOGIC
   ══════════════════════════════════════════════════════ */

function showPanel(id) {
  document.querySelectorAll('.txs-panel').forEach(function(p) { p.classList.remove('active'); });
  var el = $(id); if (el) el.classList.add('active');
  var stepMap = {'txs-p1':1,'txs-p2':2,'txs-p3':3,'txs-result':4};
  updateProgress(stepMap[id] || 1);
  var top = $('txs-calculator');
  if (top) setTimeout(function() { top.scrollIntoView({ behavior:'smooth', block:'start' }); }, 50);
}

function updateProgress(n) {
  [1,2,3,4].forEach(function(i) {
    var el = $('tp-' + i); if (!el) return;
    el.classList.remove('active','done');
    if (i < n) el.classList.add('done');
    else if (i === n) el.classList.add('active');
  });
}

function bc(text, level) {
  var h = '<span>' + text + '</span>';
  if (level >= 2 && state.spec)    h += '<span class="txs-crumb__sep">›</span><span>' + specLabel() + '</span>';
  if (level >= 3 && state.feature) h += '<span class="txs-crumb__sep">›</span><span>' + featureLabel() + '</span>';
  h += '<button class="txs-crumb__reset" onclick="txsRestart()">Start over</button>';
  return h;
}

function specLabel() {
  var o = SPEC_OPTS[state.family];
  if (!o) return state.spec;
  var found = o.opts.filter(function(x) { return x.id === state.spec; });
  return found.length ? found[0].label : state.spec;
}
function featureLabel() { return state.feature || ''; }
function familyLabel() {
  var map = {
    ls_gen3:'GM LS Gen III', ls_gen4:'GM LS Gen IV', lt:'GM Gen V LT',
    ford:'Ford', hemi:'Chrysler HEMI', stealth:'Stealth TBI', universal:'Universal MPFI'
  };
  return map[state.family] || state.family;
}

/* Step 1 — family selected */
window.txsFamily = function(fam) {
  state.family = fam; state.spec = null; state.feature = null;
  var opts = SPEC_OPTS[fam];
  if (!opts) return;

  /* Auto-advance if only one spec option */
  if (opts.opts.length === 1 && !opts.q) {
    state.spec = opts.opts[0].id;
    buildFeatures();
    return;
  }

  /* Build step 2 */
  $('txs-p2-label').textContent = 'Step 2 of 4 - Engine Specification';
  $('txs-p2-q').textContent = opts.q || 'Select your engine variant';
  $('txs-p2-hint').textContent = opts.hint || '';
  $('txs-bc2').innerHTML = bc(familyLabel(), 1);

  var grid = $('txs-spec-grid');
  var cols = opts.opts.length <= 2 ? '' : (opts.opts.length >= 6 ? ' txs-grid--3' : '');
  grid.innerHTML = '<div class="txs-grid' + cols + '">' +
    opts.opts.map(function(o) {
      return '<div class="txs-option txs-option--row" onclick="txsSpec(\'' + o.id + '\')">' +
        '<div class="txs-opt-icon">' + o.icon + '</div>' +
        '<div class="txs-opt-body">' +
          '<div class="txs-opt-name">' + o.label + '</div>' +
          '<div class="txs-opt-sub">' + o.sub + '</div>' +
          (o.tag ? '<span class="txs-opt-tag">' + o.tag + '</span>' : '') +
        '</div></div>';
    }).join('') +
  '</div>';
  showPanel('txs-p2');
};

/* Step 2 — spec selected */
window.txsSpec = function(spec) {
  state.spec = spec; state.feature = null;
  buildFeatures();
};

function buildFeatures() {
  var key = state.family + '-' + state.spec;
  var opts = FEATURE_OPTS[key];
  if (!opts || opts.length === 0) { renderResult(); return; }

  /* Auto-advance if only one option */
  if (opts.length === 1) {
    state.feature = opts[0].id;
    buildScreen();
    return;
  }

  $('txs-bc3').innerHTML = bc(familyLabel(), 2);
  var grid = $('txs-feature-grid');
  var cols = opts.length <= 2 ? '' : ' txs-grid--3';
  grid.innerHTML = '<div class="txs-grid' + cols + '">' +
    opts.map(function(o) {
      return '<div class="txs-option txs-option--row" onclick="txsFeature(\'' + o.id + '\')">' +
        '<div class="txs-opt-icon">' + o.icon + '</div>' +
        '<div class="txs-opt-body">' +
          '<div class="txs-opt-name">' + o.label + '</div>' +
          '<div class="txs-opt-sub">' + o.sub + '</div>' +
          (o.tag ? '<span class="txs-opt-tag">' + o.tag + '</span>' : '') +
        '</div></div>';
    }).join('') +
  '</div>';
  showPanel('txs-p3');
}

/* Step 3 — feature selected */
window.txsFeature = function(feature) {
  state.feature = feature;
  buildScreen();
};

function buildScreen() {
  /* Skip screen step for now - go straight to result, screen toggle in result card */
  state.screen = 'screen';
  renderResult();
}

function fmt(p) { return '£' + parseFloat(p).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,','); }

function renderResult() {
  var key = getProductKey(state.family, state.spec, state.feature);
  var p = PRODUCTS[key];
  if (!p) {
    $('txs-result-card').innerHTML = '<p style="color:rgba(255,255,255,0.5);padding:20px">Product not found for this combination. Please contact us for assistance.</p>';
    showPanel('txs-result');
    return;
  }

  var variantData = (state.screen === 'noscreen' && p.noscreen) ? p.noscreen : p.screen;
  if (!variantData) variantData = p.screen;

  /* Colour picker */
  var picker = $('txs-colour-picker');
  if (p.colours && p.colours.length > 1) {
    picker.style.display = 'flex';
    activeColour[key] = activeColour[key] || p.colours[0].vid;
    var activeC = p.colours.filter(function(c) { return c.vid === activeColour[key]; })[0] || p.colours[0];
    variantData = activeC;
    picker.innerHTML = '<span class="txs-colours__lbl">Finish:</span>' +
      p.colours.map(function(c) {
        return '<button class="txs-col-btn' + (c.vid === activeColour[key] ? ' active' : '') + '" ' +
          'data-txskey="' + key + '" data-vid="' + c.vid + '" data-sku="' + c.sku + '" ' +
          'data-price="' + c.price + '" data-handle="' + c.handle + '">' +
          '<span class="txs-col-dot" style="background:' + c.dot + '"></span>' +
          c.label + '</button>';
      }).join('');
  } else {
    picker.style.display = 'none';
  }

  /* Screen toggle */
  var screenToggle = '';
  if (p.noscreen) {
    var saving = (parseFloat(p.screen.price) - parseFloat(p.noscreen.price)).toFixed(0);
    screenToggle = '<div style="display:flex;align-items:center;gap:10px;padding:0 22px 16px;">' +
      '<span style="font-size:10px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:rgba(255,255,255,0.4);">Screen:</span>' +
      '<button class="txs-col-btn' + (state.screen !== 'noscreen' ? ' active' : '') + '" onclick="txsSetScreen(\'screen\')">3.5&quot; Handheld included</button>' +
      '<button class="txs-col-btn' + (state.screen === 'noscreen' ? ' active' : '') + '" onclick="txsSetScreen(\'noscreen\')">Without screen (save ~\xa3' + saving + ')</button>' +
      '</div>';
  }

  var html = screenToggle +
    '<div class="txs-result">' +
      '<div class="txs-result-header">' +
        '<div>' +
          '<div class="txs-result-eyebrow">&#9889; Your Matched System</div>' +
          '<div class="txs-result-title">' + p.name.toUpperCase() + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="txs-result-body">' +
        '<p class="txs-result-desc">' + p.desc + '</p>' +
        '<div class="txs-specs">' +
          '<div class="txs-spec"><div class="txs-spec__lbl">Engine</div><div class="txs-spec__val">' + p.specs.engine + '</div></div>' +
          '<div class="txs-spec"><div class="txs-spec__lbl">Injectors</div><div class="txs-spec__val">' + p.specs.injectors + '</div></div>' +
          '<div class="txs-spec"><div class="txs-spec__lbl">Trans Control</div><div class="txs-spec__val">' + p.specs.trans + '</div></div>' +
          '<div class="txs-spec"><div class="txs-spec__lbl">Screen</div><div class="txs-spec__val">' + (state.screen === 'noscreen' ? 'Laptop only' : p.specs.screen) + '</div></div>' +
        '</div>' +
        '<div class="txs-basket">' +
          '<div class="txs-basket-hdr">' +
            '<div class="txs-basket-hdr-lbl">&#128230; What You Need</div>' +
            '<div class="txs-basket-links">Links to Billy\'s Shop</div>' +
          '</div>' +
          '<div class="txs-row txs-row--req">' +
            '<div class="txs-row__dot">&#10003;</div>' +
            '<div class="txs-row__info">' +
              '<div class="txs-row__type">Terminator X ECU Kit</div>' +
              '<div class="txs-row__name">' + p.name + '</div>' +
              '<div class="txs-row__sku">SKU: ' + variantData.sku + '</div>' +
            '</div>' +
            '<div class="txs-row__price" id="txs-live-price">...</div>' +
            '<button class="txs-row__btn txs-row__btn--primary" id="txs-atb-btn" disabled style="opacity:0.6">Add to Basket &#8594;</button>' +
          '</div>' +
        '</div>' +
        '<div class="txs-total">' +
          '<div class="txs-total__lbl">Total</div>' +
          '<div class="txs-total__price" id="txs-total-price">...</div>' +
          '<div class="txs-total__note">inc. VAT &amp; import duties</div>' +
        '</div>' +
        (p.addons && p.addons.length ? '<div class="txs-addon-hdr">Recommended Add-ons for this Build</div>' +
          p.addons.map(function(a) {
            return '<div class="txs-row txs-row--add">' +
              '<div class="txs-row__dot">+</div>' +
              '<div class="txs-row__info">' +
                '<div class="txs-row__type">' + a.t + '</div>' +
                '<div class="txs-row__name">' + a.n + '</div>' +
                '<div class="txs-row__sku">SKU: ' + a.sku + '</div>' +
              '</div>' +
              '<div class="txs-row__price">£' + parseFloat(a.price).toFixed(2) + '</div>' +
              '<button class="txs-row__btn txs-row__btn--ghost txs-addon-atb" data-sku="' + a.sku + '" data-vid="' + a.vid + '" data-handle="' + a.h + '">Add →</button>' +
            '</div>';
          }).join('') : '') +
        '<div class="txs-actions">' +
          '<a href="/collections/manufacturer-holley-efi" class="txs-row__btn txs-row__btn--ghost">Browse All Terminator X</a>' +
        '</div>' +
        '<div class="txs-reminder">' +
          '<div class="txs-reminder__title">EFI System Note</div>' +
          '<p>ECU kits do not include fuel pump, injectors, throttle body (for MPFI kits) or air intake. Billy\'s can supply everything you need - call us for a full build quote.</p>' +
        '</div>' +
      '</div>' +
    '</div>';

  $('txs-bc-result').innerHTML = bc(familyLabel(), 3);
  $('txs-result-card').innerHTML = html;
  showPanel('txs-result');

  /* Fetch live price from Shopify product JSON */
  fetchLivePrice(variantData.handle, variantData.vid, variantData.sku);
}

function fetchLivePrice(handle, vid, sku) {
  var vidInt = parseInt(vid, 10);
  fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === vidInt) { variant = product.variants[i]; break; }
      }
      if (!variant) return;

      var pence = variant.price;
      var priceStr = '\xa3' + (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      var priceEl = $('txs-live-price');
      var totalEl = $('txs-total-price');
      var atbBtn  = $('txs-atb-btn');

      if (priceEl) priceEl.textContent = priceStr;
      if (totalEl) totalEl.textContent = priceStr;
      if (atbBtn) {
        atbBtn.disabled = false;
        atbBtn.style.opacity = '';
        atbBtn.setAttribute('onclick',
          'txsAddToCart(\'' + sku + '\',this,' + vid + ',\'' + handle + '\')');
      }

      /* Update all colour btn data-price with live values */
      for (var j = 0; j < product.variants.length; j++) {
        var v = product.variants[j];
        var btn = document.querySelector('.txs-col-btn[data-vid="' + v.id + '"]');
        if (btn) btn.dataset.price = (v.price / 100).toFixed(2);
      }
    })
    .catch(function() {
      /* Fetch failed - enable button anyway with stored VID */
      var atbBtn = $('txs-atb-btn');
      if (atbBtn) {
        atbBtn.disabled = false;
        atbBtn.style.opacity = '';
        atbBtn.setAttribute('onclick',
          'txsAddToCart(\'' + sku + '\',this,' + vid + ',\'' + handle + '\')');
      }
      var priceEl = $('txs-live-price');
      var totalEl = $('txs-total-price');
      if (priceEl) priceEl.textContent = 'See product';
      if (totalEl) totalEl.textContent = 'See product';
    });
}

window.txsSetScreen = function(val) {
  state.screen = val;
  renderResult();
};

/* Colour picker — delegated click */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.txs-col-btn');
  if (!btn || !btn.dataset.txskey) return;
  var key = btn.dataset.txskey;
  var vid = parseInt(btn.dataset.vid, 10);
  activeColour[key] = vid;
  /* Update active state */
  var picker = $('txs-colour-picker');
  if (picker) picker.querySelectorAll('.txs-col-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  /* Update Add to Basket button */
  var atbBtn = $('txs-atb-btn');
  if (atbBtn) {
    atbBtn.setAttribute('onclick',
      'txsAddToCart(\'' + btn.dataset.sku + '\',this,' + vid + ',\'' + btn.dataset.handle + '\')');
  }
  var total = $('txs-total-price');
  if (total) total.textContent = fmt(btn.dataset.price);
  /* Update SKU */
  var skuEl = document.querySelector('.txs-row__sku');
  if (skuEl) skuEl.textContent = 'SKU: ' + btn.dataset.sku;
  /* Update price in row */
  var priceEl = document.querySelector('.txs-row--req .txs-row__price');
  if (priceEl) priceEl.textContent = fmt(btn.dataset.price);
});

/* Add to cart */
window.txsAddToCart = function(sku, btn, vid, handle) {
  var orig = btn.textContent;
  btn.textContent = 'Adding...'; btn.disabled = true;
  fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ id: vid, quantity: 1 })
  }).then(function(r) {
    if (!r.ok) throw new Error('Cart error');
    btn.textContent = 'Added ✓';
    btn.style.background = '#16a34a';
    setTimeout(function() { btn.textContent = orig; btn.style.background = ''; btn.disabled = false; }, 2500);
    /* Trigger Shopify cart drawer refresh */
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
      /* Dawn / Impulse / most themes listen for this */
      var evt = new CustomEvent('dispatch', { detail: { type: 'cart:refresh' } });
      document.dispatchEvent(evt);
    });
  }).catch(function() {
    btn.textContent = 'View Product';
    btn.disabled = false;
    btn.onclick = function() { window.location.href = '/products/' + handle; };
  });
};

/* Restart */
window.txsRestart = function() {
  state = { family:null, spec:null, feature:null, screen:null };
  activeColour = {};
  document.querySelectorAll('.txs-col-btn').forEach(function(b) { b.classList.remove('active'); });
  var picker = $('txs-colour-picker');
  if (picker) { picker.innerHTML = ''; picker.style.display = 'none'; }
  showPanel('txs-p1');
};

  /* ── Delegated event listeners (replaces inline onclick) ── */
  document.addEventListener('click', function(e) {
    /* Engine family cards */
    var familyEl = e.target.closest('[data-txs-family]');
    if (familyEl) { window.txsFamily(familyEl.dataset.txsFamily); return; }

    /* Spec options — generated dynamically, still use onclick in JS */
    /* Feature options — generated dynamically, still use onclick in JS */

    /* Restart button */
    var restartEl = e.target.closest('[data-txs-action="restart"]');
    if (restartEl) { window.txsRestart(); return; }

    /* Addon add-to-basket buttons */
    var addonBtn = e.target.closest('.txs-addon-atb');
    if (addonBtn) {
      window.txsAddToCart(addonBtn.dataset.sku, addonBtn, parseInt(addonBtn.dataset.vid,10), addonBtn.dataset.handle);
      return;
    }

    /* Colour picker */
    var colBtn = e.target.closest('.txs-col-btn[data-txskey]');
    if (colBtn) {
      var key = colBtn.dataset.txskey;
      var vid = parseInt(colBtn.dataset.vid, 10);
      activeColour[key] = vid;
      var picker = $('txs-colour-picker');
      if (picker) picker.querySelectorAll('.txs-col-btn').forEach(function(b) { b.classList.remove('active'); });
      colBtn.classList.add('active');
      var atbBtn = $('txs-atb-btn');
      if (atbBtn) atbBtn.setAttribute('onclick', 'txsAddToCart(\'' + colBtn.dataset.sku + '\',this,' + vid + ',\'' + colBtn.dataset.handle + '\')');
      var total = $('txs-total-price');
      if (total) total.textContent = fmt(colBtn.dataset.price);
      var skuEl = document.querySelector('.txs-row__sku');
      if (skuEl) skuEl.textContent = 'SKU: ' + colBtn.dataset.sku;
      var priceEl = document.querySelector('.txs-row--req .txs-row__price');
      if (priceEl) priceEl.textContent = fmt(colBtn.dataset.price);
      return;
    }
  });

})();
